import React from 'react';
import { connect } from 'react-redux';

import BreadCrumb from 'jbc-front/components/BreadCrumb';
import { CLIENT_SETTINGS } from 'src/constants/EndpointUrls';
import { setItem } from 'src/reducers/common/itemReducer';
import { REDUCER_NAME } from 'src/reducers/clients/commutingFeeSettings';

import EditClientCommutingFeeSettingForm from './containers/EditClientCommutingFeeSettingForm';
import { useTranslation } from 'react-i18next';

const ClientCommutingFeeSetting = ({ clientCommutingFeeSetting, dispatch }) => {
  if (clientCommutingFeeSetting) {
    dispatch(setItem(REDUCER_NAME, clientCommutingFeeSetting));
  }
  const { t } = useTranslation();
  return (
    <div>
      <div className="l-main-title-wrap">
        <h1 className="m-title-main">{t('features.Settings.Settings.commuting_allowance_upper_limit_setting')}</h1>
      </div>
      <div className="l-wrap-xs l-contents-wrap">
        <div className="u-mb20">
          <BreadCrumb>
            <BreadCrumb.Item label={t('components.SideMenu.SideMenu.setting')} path={CLIENT_SETTINGS} />
            <BreadCrumb.Item label={t('features.Settings.Settings.commuting_allowance_upper_limit_setting')} />
          </BreadCrumb>
        </div>
        <EditClientCommutingFeeSettingForm />
      </div>
    </div>
  );
};

export default connect()(ClientCommutingFeeSetting);
